import React, { useState } from "react";
import EnterpriseGridCommon from "./Ag-Grid";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useTranslation } from "react-i18next";
import ExclamationIcon from "../../assets/exclamation.svg";
import {
  aggridHelpers,
  COLUMN_WIDTHS,
} from "../../helpers/common/ag-grid-helper";
import { logDataHelperFunctions } from "../../helpers/logdata-helper";
import { zoneViewHelper } from "../../helpers/zone-view/zone-view-helper";

const ZoneViewGrid = ({
  rows,
  isLoading,
  reportColumns,
  handleRowClick,
  hideStatus,
}) => {
  const { t } = useTranslation();

  const valueRender = (params) => {
    const text = params.value;
    if (text && typeof text === "string" && text.includes("-color")) {
      return (
        <div>
          <p className="red-note-text">
            <span className="red-note">
              {Number(text.replace("-color", ""))}
            </span>
          </p>
        </div>
      );
    }
    return isNaN(text) ? "" : Number(text);
  };

  function resolveNested(obj, path) {
    return path.split(".").reduce((o, key) => (o ? o[key] : undefined), obj);
  }

  const unitsCommonFilter = {
    pivot: true,
    floatingFilter: true,
    filter: "agMultiColumnFilter",
    filterParams: {
      maxNumConditions: 1,
      filters: [
        {
          filter: "agNumberColumnFilter",
          filterParams: {
            valueFormatter: (params) => {
              return params.value && typeof params.value === "string"
                ? params.value.replace("-color", "")
                : params.value || "";
            },
            maxNumConditions: 1,
          },
        },
      ],
    },
    valueGetter: (params) => {
      const value = resolveNested(params.data, params.colDef.field);
      return Number(
        value && typeof value === "string"
          ? value.replace("-color", "")
          : value || 0
      );
    },

    processCellForExport: (params) => {
      return params.value && typeof params.value === "string"
        ? params.value.replace("-color", "")
        : params.value;
    },
    pivotComparator: (a, b) => b.localeCompare(a),
    cellRenderer: (params) => {
      const value = resolveNested(params.data, params.colDef.field);

      return valueRender({
        value: value,
      });
    },
  };

  const [columnDefs] = useState([
    {
      headerName: t("slogColumntitle.sl.no"),
      field: "sl_no",

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      key: "name",
      pivotComparator: (a, b) => b.localeCompare(a),
      width: COLUMN_WIDTHS.small,
    },
    ...(hideStatus
      ? []
      : [
          {
            headerName: t("slogColumntitle.status"),
            field: "status",

            pivot: true,
            floatingFilter: true,
            filter: "agMultiColumnFilter",
            filterParams: {
              filters: [
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    cellHeight: 40,
                    cellRenderer: (params) => {
                      const status = String(params.value);
                      if (status === "(Select All)") {
                        return "(Select All)";
                      }
                      return logDataHelperFunctions.getIconForStatus(status);
                    },
                    valueFormatter: (params) => {
                      return String(params.value);
                    },
                  },
                },
              ],
              maxNumConditions: 1,
            },
            pivotComparator: (a, b) => b.localeCompare(a),
            key: "status",

            cellRenderer: (params) => {
              return params.value
                ? logDataHelperFunctions.getIconForStatus(params.value)
                : "";
            },
            processCellForExport: (params) => {
              return params.value
                ? logDataHelperFunctions.getExportValueForStatus(params.value)
                : "";
            },
            width: COLUMN_WIDTHS.small,
          },
        ]),
    {
      headerName: t("slogColumntitle.stationName"),
      field: "stationNumbers",
      key: "stationName",

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },

      pivotComparator: (a, b) => b.localeCompare(a),
      width: COLUMN_WIDTHS.medium,
    },
    {
      headerName: t("slogColumntitle.buyType"),
      field: "buyType",

      key: "buyType",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },

      pivotComparator: (a, b) => b.localeCompare(a),
      width: COLUMN_WIDTHS.medium,
    },
    {
      headerName: t("slogColumntitle.torch"),
      field: "type",

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },

      pivotComparator: (a, b) => b.localeCompare(a),
      key: "type",
      width: COLUMN_WIDTHS.medium,
    },
    {
      headerName: t("slogColumntitle.pass"),
      field: "pass",

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      key: "pass",

      pivotComparator: (a, b) => b.localeCompare(a),
      cellRenderer: (params) => {
        return params.value == "!" ? (
          <img src={ExclamationIcon} alt="Exclamation" />
        ) : (
          params.value
        );
      },
      width: COLUMN_WIDTHS.medium,
    },
    {
      headerName: t("slogColumntitle.zone"),
      field: "zone",

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      key: "zone",
      pivotComparator: (a, b) => b.localeCompare(a),
      cellRenderer: (params) => {
        return params.value == "!" ? (
          <img src={ExclamationIcon} alt="Exclamation" />
        ) : (
          params.value
        );
      },
      width: COLUMN_WIDTHS.medium,
    },
    {
      headerName: t("slogColumntitle.weldstartTime"),
      field: "weldStartTimeRaw",

      key: "weldStartTime",
      cellRenderer: (params) => {
        return Number(params.value) > 0
          ? logDataHelperFunctions.formatWeldStartTime(
              params.value,
              false,
              false,
              true
            )
          : "-";
      },
      processCellForExport: (params) => {
        return Number(params.value) > 0
          ? logDataHelperFunctions.formatWeldStartTime(
              params.value,
              false,
              false,
              true
            )
          : "-";
      },
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        filters: [
          {
            filter: "agDateColumnFilter",
            filterParams: {
              comparator: (filterLocalDateAtMidnight, cellValue) => {
                return aggridHelpers.dateFilter(
                  filterLocalDateAtMidnight,
                  cellValue
                );
              },
              maxNumConditions: 1,
              inRangeInclusive: true,
            },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              cellRenderer: (params) => {
                const value = String(params.value);
                if (value === "(Select All)") {
                  return "(Select All)";
                }
                return Number(params.value) > 0
                  ? logDataHelperFunctions.formatWeldStartTime(
                      params.value,
                      false,
                      false,
                      true
                    )
                  : "-";
              },

              comparator: (filterLocalDateAtMidnight, cellValue) => {
                return aggridHelpers.dateFilter(
                  filterLocalDateAtMidnight,
                  cellValue
                );
              },
            },
          },
        ],
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("slogColumntitle.weldTime"),
      field: "weld_time",
      key: "weldTime",

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: {
              maxNumConditions: 1,
            },
          },
        ],
      },
      valueGetter: (params) => {
        const value = resolveNested(params.data, params.colDef.field);
        return isNaN(value) ? value : Number(value);
      },
      pivotComparator: (a, b) => b.localeCompare(a),
      width: COLUMN_WIDTHS.large,
    },
    {
      headerName: t("slogColumntitle.autoIncrement"),
      field: "autoIncrement",
      key: "autoIncrement",

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },

      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("slogColumntitle.current"),
      key: "currentA",
      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "current_low",

          key: "currentLow",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "current_avg",
          key: "currentAvg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "current_high",
          key: "currentHigh",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.volt"),
      key: "voltV",
      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "volt_low",
          key: "voltLow",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "volt_avg",
          key: "voltAvg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "volt_high",
          key: "voltHigh",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.travelSpeed"),
      key: "travelSpeed",
      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "travel_speed_low",
          key: "travelLow",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "travel_speed_avg",
          key: "travelAvg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "travel_speed_high",
          key: "travelHigh",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.trueEnergy"),
      key: "trueEnergy",

      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "true_energy_low",
          key: "travelLow",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "true_energy_avg",
          key: "travelAvg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "true_energy_high",
          key: "travelHigh",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.heat"),
      key: "heat",

      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "heat_low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "heat_avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "heat_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.wireSpeed"),
      key: "wireSpeed",
      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "wire_speed_low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "wire_speed_avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "wire_speed_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.oscillationWidth"),
      key: "oscillationWidth",

      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "oscillation_width_low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "oscillation_width_avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "oscillation_width_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.frequency"),
      key: "frequency",

      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "frequency_low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "frequency_avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "frequency_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.target"),
      key: "target",

      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "target_low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "target_avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "target_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.horizontalBias"),
      key: "horizontalBias",

      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "horizontal_bias_low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "horizontal_bias_avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "horizontal_bias_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.totalWireConsumed"),
      key: "totalWireConsumed",

      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "total_wire_consumed_low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "total_wire_consumed_avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "total_wire_consumed_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.arcImpedance"),
      key: "arcImpedance",
      children: [
        {
          headerName: t("slogColumntitle.low"),
          field: "arc_impedance_low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          field: "arc_impedance_avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          field: "arc_impedance_high",
          ...unitsCommonFilter,
        },
      ],
    },
  ]);

  const onRowClicked = (params) => {
    console.log("Row clicked", params);
    handleRowClick(params.data);
  };

  const processCellCallback = (params) => {
    if (params?.column?.colDef?.processCellForExport) {
      return params.column.colDef.processCellForExport(params);
    }

    return params.value;
  };

  return (
    <div className="ag-theme-alpine" style={{ width: "100%" }}>
      <EnterpriseGridCommon
        isLoading={isLoading}
        rows={rows}
        columnDefs={zoneViewHelper.mapZoneViewColumnTitles(
          columnDefs,
          reportColumns
        )}
        onRowClicked={onRowClicked}
        exportFileName={"zone-view"}
        processCellCallback={processCellCallback}
        heightValue={-150}
      />
    </div>
  );
};

export default ZoneViewGrid;
